import {AppProps} from "next/app";
import {EmotionCache} from "@emotion/react";
// lib/withApollo.tsx
import withApollo from 'next-with-apollo'
import { getDataFromTree } from '@apollo/client/react/ssr'
import initializeApollo from "@gqlapp/core-common/init";

export interface MyAppProps extends AppProps {
	emotionCache?: EmotionCache;
	apollo?: any;
}

export async function safeGetDataFromTree(AppTree: any, props: any) {
	try {
		// 🔴 AppTree ĐÃ LÀ ReactElement
		return await getDataFromTree(AppTree);
	} catch (err) {
		console.error('SSR Apollo error:', err);
		props.__APOLLO_SSR_ERROR__ = true;
	}
}

export default function WithApollo(clientModules: any){
	return withApollo(
		({ initialState, ...ctx }: any) => {
			return initializeApollo({ initialState, clientModules }, ctx);
		},
		{ getDataFromTree: safeGetDataFromTree }
	)
}